import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { HELP_EMAIL } from './nav';

export function Footer({ onTerms }: { onTerms: () => void }) {
  return (
    <Box component="footer" sx={{ borderTop: '1px solid', borderColor: 'divider', py: 2, px: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
        © Mollusk Inc · Evaluation use only ·{' '}
        <Link
          component="button"
          variant="body2"
          onClick={onTerms}
          sx={{ verticalAlign: 'baseline' }}
        >
          Terms
        </Link>{' '}
        · <Link href={`mailto:${HELP_EMAIL}`}>{HELP_EMAIL}</Link>
      </Typography>
    </Box>
  );
}
